const en = require("./language_json/en.json");

export default en;
